import { getJsonFromStorage } from "@/util/storageUtils";
import api from "@/api/axiosApi";
const getMenuByModule = (profile, menus) => {
  let availableMenus = [];
  menus.forEach((m) => {
    if (m.profile.includes(profile)) availableMenus.push(m);
  });
  return availableMenus;
};

const state = {
  userData: getJsonFromStorage("userData") || null,
  userMenus: [],
  token: localStorage.getItem("token") || null,
  idObjectifToModify: null,
};

const mutations = {
  setUserData(state, { userData, token }) {
    // set user data & token
    state.userData = userData;
    state.token = token;

    localStorage.setItem("userData", JSON.stringify(userData)); 
    localStorage.setItem("token", token);
    // setAuthToken(response.token);
  },

  setIdObjectifToModify(state, idObjectif) {
    state.idObjectifToModify = idObjectif;
  },
  clearIdObjectifToModify(state) {
    state.idObjectifToModify = null;
  },

  logout(state) {
    state.userData = null;
    state.token = null;
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("token");
    localStorage.removeItem("userData");
    localStorage.removeItem("tempObjectives");
  },
};
const actions = {
  saveIdObjectifToModify({ commit }, idObjectif) {
    commit("setIdObjectifToModify", idObjectif);
  },
  clearIdObjectifToModify({ commit }) {
    commit("clearIdObjectifToModify");
  },
  async logoutComplet({ commit }) {
    const token = localStorage.getItem("token");
    try {
      if (token) {
        await api.get("/auth/logout", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
    } catch (error) {
      console.warn("Erreur lors du logout côté backend :", error);
    }

    commit("logout");

    window.location.href = "/login";
  },
};
const getters = {
  userData: (state) => state.userData,
  userRole: (state) => (state.userData ? state.userData.role : null),
  getMenuForRole: (state, getters) => (menus) => {
    return getters.userRole ? getMenuByModule(getters.userRole, menus) : [];
  },
  getIdObjectifToModify(state) {
    return state.idObjectifToModify;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
    actions,
  getters,
};
